import styled from "styled-components";
import {IoMdRemoveCircle} from "react-icons/io";

const MinusIcon = styled(IoMdRemoveCircle)`
  color: #E66C6C;
  font-size: 1.875rem;  
  cursor: pointer;
`

export default MinusIcon;